import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, FileText, HelpCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 to-slate-800 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        {/* 404 Number */}
        <div className="relative">
          <h1 className="text-[150px] font-bold text-slate-700/30 leading-none select-none">
            404
          </h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-24 h-24 bg-amber-500/20 rounded-full flex items-center justify-center">
              <HelpCircle className="w-12 h-12 text-amber-500" />
            </div>
          </div>
        </div>

        {/* Message */}
        <h2 className="text-2xl font-bold text-white mt-4 mb-2">
          Page Not Found
        </h2>
        <p className="text-slate-400 mb-8">
          Oops! The page you're looking for doesn't exist or has been moved.
          Let's get you back on track to building your career.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            asChild
            className="bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold"
          >
            <Link to="/">
              <Home className="w-4 h-4 mr-2" />
              Go Home
            </Link>
          </Button>
          <Button
            asChild
            variant="outline"
            className="border-slate-600 text-slate-300 hover:bg-slate-700"
          >
            <Link to="/dashboard">
              <FileText className="w-4 h-4 mr-2" />
              My Dashboard
            </Link>
          </Button>
        </div>

        {/* Back Link */}
        <button
          onClick={() => window.history.back()}
          className="mt-6 text-slate-500 hover:text-slate-300 text-sm flex items-center justify-center gap-1 mx-auto transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Go back to previous page
        </button>

        {/* Help Text */}
        <p className="mt-8 text-slate-600 text-xs">
          Need help? Contact us at{' '}
          <a href="mailto:support@careerstep.co.za" className="text-amber-500 hover:underline">
            support@careerstep.co.za
          </a>
        </p>
      </div>
    </div>
  );
};

export default NotFoundPage;
